import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyNextTier from 'loyalty/selectors/getLoyaltyNextTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'

/**
 * Returns the current loyalty tier for the user
 * If not entered in the program, will return the 'base' default tier
 */
function useCurrentLoyaltyTier(): [tier: App.LoyaltyTier, tierName: string, nextTier: App.LoyaltyTier | undefined, nextTierName: string | undefined] {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const nextTier = useAppSelector(getLoyaltyNextTier)

  return [
    tier,
    getLoyaltyTierDisplayName(tier),
    nextTier,
    nextTier ? getLoyaltyTierDisplayName(nextTier) : undefined,
  ]
}

export default useCurrentLoyaltyTier
